import { createSlice } from '@reduxjs/toolkit';
import { fetchJuOrju } from '../action/juOrjuAction';
const initialState = {
    juOrJu: null,
    juEnv: null,
    ownSchedule: false,
    ownAllowed: false,
    isLoaderJu: false,
    isErrorJu: false
};
export const JuOrJuSlice = createSlice({
    initialState,
    name: 'juOrJu',
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchJuOrju.pending, (state) => {
            state.isLoaderJu = true;
            state.isErrorJu = false;
        })
            .addCase(fetchJuOrju.fulfilled, (state, action) => {
            state.juOrJu = action.payload.mode;
            state.juEnv = action.payload.env;
            state.ownSchedule = action.payload.own;
            state.ownAllowed = action.payload.ownAllowed;
            state.isLoaderJu = false;
        })
            .addCase(fetchJuOrju.rejected, (state) => {
            state.isLoaderJu = false;
            state.isErrorJu = true;
        });
    }
});
export default JuOrJuSlice.reducer;
